module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Ge-Ha-Id-Ja.c9de8652.png";